import { result } from 'underscore';
import { BaseSurvey } from '../base-survey';
import { FactorySurveyView } from './factory-view';
import { SurveyView } from './view';

export class WebuiUserSurvey extends BaseSurvey {
  getSurveyName = () => 'WebuiUserSurvey';

  getSurveyProduct = () => 'Expert';

  getSurveyInterface = () => 'Web';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    '65ad291c-e0ee-4f45-958f-42497060ea28' : '94d8fa3e-cc2f-4adf-a04f-abe716426178';

  getInitializationConfig = () => ({
    initGroup: 100,
    initStartDate: '2022-12-09',
    initEndDate: '2023-06-09',
  });

  isWebUIUserCSATSurveyByFactoryEnabled = () => // should enable the pilot (pilot by percentage of user Id)
    result(this.serverContext, ['Permissions', 'IsWebUIUserCSATSurveyByFactoryEnabled']);

  checkUserCreatedDateTime = (userCreatedDateTime, offset) => {
    const localizedUserCreatedDateTime = new Date(userCreatedDateTime);
    const surveyPreferenceSeveralDaysAgo = this.SurveyPreferenceService.getDaysAgo(offset);
    const isUserActive = localizedUserCreatedDateTime <= surveyPreferenceSeveralDaysAgo;
    return isUserActive;
  };

  getUserActiveDay = () => {
    const userCreatedDateTime = result(this.serverContext, ['CurrentUser', 'FetchedCreatedDateTime']) || result(this.serverContext, ['CurrentUser', 'CreatedDateTime']);
    const localizedUserCreatedDateTime = new Date(userCreatedDateTime);
    const now = new Date();
    const deltaTime = now.getTime() - localizedUserCreatedDateTime.getTime();
    const deltaDay = Math.ceil(deltaTime / (1 * 24 * 60 * 60 * 1000));
    return deltaDay;
  };

  validateTriggerCondition = () => {
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);

    // should enable the pilot (pilot by percentage of user Id)
    const isPilotEnabled = result(this.serverContext, ['Permissions', 'IsWebUIUserCSATSurveyEnabled']) || this.isWebUIUserCSATSurveyByFactoryEnabled();

    if (!isPilotEnabled) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isPilotEnabled: ${isPilotEnabled}`);
      return false;
    }

    // should not be AAD users, AAD users can be included in the future after OCPS integration
    const isNonAADUser = !result(this.serverContext, 'IsAADUser');

    if (!isNonAADUser) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isNonAADUser: ${isNonAADUser}`);
      return false;
    }

    // should be active user more than 30 days
    const userCreatedDateTime = result(this.serverContext, ['CurrentUser', 'CreatedDateTime']);
    const isUserActiveOneMonth = this.checkUserCreatedDateTime(userCreatedDateTime, 30);

    if (!this.isTestEnv && !isUserActiveOneMonth) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isTestEnv: ${this.isTestEnv}, isUserActiveOneMonth: ${isUserActiveOneMonth}, userCreatedDateTime: ${userCreatedDateTime}`);
      return false;
    }

    // should have campaign in the account (ignore this condition for broader audience)
    // const isAccountHasCampaign = result(window, ['survey', 'hasCampaign']);

    // if (!this.isTestEnv && !isAccountHasCampaign) {
    //   this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isAccountHasCampaign: ${isAccountHasCampaign}`);
    //   return false;
    // }

    // conditions copied from Qualtrics
    const isEnglishUser = result(this.serverContext, ['CurrentUser', 'Language']) === 'EN';
    const isBrowserLanguageEnglish = result(this.serverContext, ['CurrentLocale'], '').startsWith('en');
    const isNotInternalUser = result(this.serverContext, ['CurrentUser', 'IsInternal']) !== true;
    const isNotSupportUser = !result(this.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
    const isNotExcludedUser = result(this.serverContext, ['CurrentUser', 'Id']) !== 102004780;
    const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
    const isProdUrl = window.location.href.toLocaleLowerCase().includes('https://ui.ads.microsoft.com/');
    const isNotMcaUrl = !window.location.href.toLocaleLowerCase().includes('campaign/mca');

    const qualtricsConditions =
      this.isTestEnv || // should be test env
      (isEnglishUser && // should be English user
      isBrowserLanguageEnglish && // should browser language be English
      isNotInternalUser && // not internal users
      isNotSupportUser && // not support team users
      isNotExcludedUser && // not excluded users
      !isDisabledInBVT && // should not be disabled in BVT
      isProdUrl && // should be Prod URL
      isNotMcaUrl); // should not be MCA URL

    if (!qualtricsConditions) {
      if (!isEnglishUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isEnglishUser: ${isEnglishUser}`);
        return false;
      }

      if (!isBrowserLanguageEnglish) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isBrowserLanguageEnglish: ${isBrowserLanguageEnglish}`);
        return false;
      }

      if (!isNotInternalUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotInternalUser: ${isNotInternalUser}`);
        return false;
      }

      if (!isNotSupportUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotSupportUser: ${isNotSupportUser}`);
        return false;
      }

      if (!isNotExcludedUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotExcludedUser: ${isNotExcludedUser}`);
        return false;
      }

      if (!isProdUrl) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isProdUrl: ${isProdUrl}`);
        return false;
      }

      if (!isNotMcaUrl) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotMcaUrl: ${isNotMcaUrl}`);
        return false;
      }

      return false;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Pass. userCreatedDateTime: ${userCreatedDateTime}`);

    return true;
  };

  getSurveyComponent = () => (this.isWebUIUserCSATSurveyByFactoryEnabled() ? FactorySurveyView : SurveyView);

  isReportingPipelineEnabled = () => true;

  getSurveyCustomParams = () => ({
    IsLeftNavigationHideButtonEnabled: result(this.serverContext, ['Permissions', 'IsLeftNavigationHideButtonEnabled']),
    IsHideCampaignListButtonEnabled: result(this.serverContext, ['Permissions', 'IsHideCampaignListButtonEnabled']),
    IsLongCampaignAndAdgroupNameEnabled: result(this.serverContext, ['Permissions', 'IsLongCampaignAndAdgroupNameEnabled']),
    IsImprovedDateFilterEnabled: result(this.serverContext, ['DynamicPermissions', 'ImprovedDateFilter']),
    AdsCopilot: true,
    NavigationRefresh: result(this.serverContext, ['DynamicPermissions', 'NavigationRefresh']),
    PopupOutsideDismiss: result(this.serverContext, ['DynamicPermissions', 'PopupOutsideDismiss']),
    EnhancedSurveyTriggerCondition: result(this.serverContext, ['DynamicPermissions', 'EnhancedSurveyTriggerCondition']),
    isUserActive10Days: this.checkUserCreatedDateTime(result(this.serverContext, ['CurrentUser', 'FetchedCreatedDateTime']) || result(this.serverContext, ['CurrentUser', 'CreatedDateTime']), 10),
    isUserActiveOneMonth: this.checkUserCreatedDateTime(result(this.serverContext, ['CurrentUser', 'FetchedCreatedDateTime']) || result(this.serverContext, ['CurrentUser', 'CreatedDateTime']), 30),
    userActiveDay: this.getUserActiveDay(),
  });
}
